import React from "react";
import { useTranslation } from "react-i18next";
import { HeaderConfiguration } from "../common";
import LoginFormModal from "./LoginFormModal";

interface CategoryMenuLoginContainerProperties {
    readonly headerConfiguration: HeaderConfiguration;
}

export default function CategoryMenuLoginContainer({ headerConfiguration }: CategoryMenuLoginContainerProperties): React.JSX.Element {
    const { t } = useTranslation("header");
    const [isLoginFormOpen, setIsLoginFormOpen] = React.useState<boolean>(false);

    if (headerConfiguration.isLoggedIn) {
        return (
            <div className="mobile-login visible-xs visible-sm">
                <a href={headerConfiguration.logoutUrl} rel="nofollow">
                    <div className="col-xs-12">
                        <div className="header-categories-menu-modal-item-wrap">
                            <i className="fa-solid fa-sign-out-alt"></i>
                            {t("logout")}
                        </div>
                    </div>
                </a>
                <a href={headerConfiguration.myOrdersUrl} rel="nofollow">
                    <div className="col-xs-12">
                        <div className="header-categories-menu-modal-item-wrap">
                            <i className="fa-solid fa-bars"></i>
                            {t("myAccount")}
                        </div>
                    </div>
                </a>
            </div>
        );
    }

    return (
        <div className="mobile-login visible-xs visible-sm">
            <a href="#" rel="nofollow" onClick={() => setIsLoginFormOpen(true)}>
                <div className="col-xs-12">
                    <div className="header-categories-menu-modal-item-wrap">
                        <i className="fa-solid fa-sign-in-alt"></i>
                        {t("login")}
                    </div>
                </div>
            </a>
            <LoginFormModal
                onAfterClose={() => setIsLoginFormOpen(false)}
                forceOpenModal={isLoginFormOpen} />
            <a href={headerConfiguration.registerUrl}>
                <div className="col-xs-12">
                    <div className="header-categories-menu-modal-item-wrap">
                        <i className="fa-solid fa-user-plus"></i>
                        {t("register")}
                    </div>
                </div>
            </a>
        </div>
    );
}
